export function formatDate(inputDate) {
    const year = inputDate?.substring(0, 4);
    const month = inputDate?.substring(4, 6);
    const day = inputDate?.substring(6, 8);

    return `${parseInt(month, 10)}/${parseInt(day, 10)}/${year}`;
}

export const dueDateAfterFormat = (dateData) => {
    if(!dateData) return '';
    return dateData.split('/').map((data) => Number(data)).join('/');
};

export const todaysDate = () => {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Months are zero-based
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();
    return `${month}/${day}/${year}`;
};

export function formatDateForAPICall(dateString, index, planId) {
    const year = dateString?.slice(0, 4);
    const month = dateString?.slice(4, 6);
    const day = dateString?.slice(6, 8);

    // Convert year, month, and day to integers
    const yearInt = parseInt(year);
    const monthInt = parseInt(month) - 1; // Subtract 1 from monthInt
    const dayInt = parseInt(day);

    // Create a Date object with the given year, month, and day
    const originalDate = new Date(yearInt, monthInt, dayInt);

    // Extract the new year, month, and day
    const newYear = originalDate.getFullYear();
    const newMonth = (originalDate.getMonth() + 1).toString().padStart(2, '0'); // Add 1 back for display
    const newDay = originalDate.getDate().toString().padStart(2, '0'); // Ensure double digits

    // Format the new date string
    const formattedDate = `${newYear}${newMonth}${newDay}`;

    return formattedDate;
}

export function formatDateToYYYYMMDD(date) {
    const selectedDate=new Date(date)
    const year = selectedDate?.getFullYear();
    const month = ('0' + (selectedDate.getMonth() + 1)).slice(-2); // Adding leading zero if necessary
    const day = ('0' + selectedDate.getDate()).slice(-2); // Adding leading zero if necessary
    return `${year}${month}${day}`;
}
export function formatDateToMMDDYYYY(date) {

    const year = date?.substring(0, 4);
    const month = date?.substring(4, 6);
    const day = date?.substring(6, 8);

    const newDate= new Date(year, month, day);
    const year1 = newDate?.getFullYear();
    const month1 = ('0' + (newDate.getMonth() + 1)).slice(-2); // Adding leading zero if necessary
    const day1 = ('0' + newDate.getDate()).slice(-2); // Adding leading zero if necessary

    return `${month1}/${day1}/${year1}`;
}
export function calcWorkingDays(fromDate: any, days: any) {
    let count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() + 1);
      if (fromDate.getDay() != 0 && fromDate.getDay() != 6) // Skip weekends
        count++;
    }
    return fromDate;
  }
  
 export function calculateDays(fromDate: any, toDate: any) {
    const date1: any = fromDate;
    const date2: any = toDate;
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
    return diffDays;
  }
  
  export  function calcWorkingDaysByExcludingSunday(fromDate: any, days: any) {
    let count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() + 1);
      if (fromDate.getDay() != 0)  //Date.getDay() gives weekday starting from 0(Sunday) to 6(Saturday)
        count++;
    }
    return fromDate;
  }
  export const formatedDateWithTime = (pickedDate: any) => {
    pickedDate = new Date(pickedDate);
    const yyyy = pickedDate.getFullYear();
    let mm = pickedDate.getMonth() + 1; // Months start at 0!
    let dd = pickedDate.getDate();
  
    if (mm < 10) {
      mm = '0' + mm;
    }
    if (dd < 10) {
      dd = '0' + dd;
    }
  
    const hours = pickedDate.getHours();
    const minutes = pickedDate.getMinutes();
    const seconds = pickedDate.getSeconds();
    const milliseconds = pickedDate.getMilliseconds();
  
  
    const date: string = `${yyyy}-${mm}-${dd}`;
    const timeStamp: string = `${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    const formtedDate = `${date}T${timeStamp}`;
    return formtedDate;
  }
  export function addDays(fromDate: any, days: any) {
    const startDate: any = fromDate;
    startDate.setDate(startDate.getDate() + days);
    const day = startDate.getDate();
    const month = startDate.getMonth() + 1;
    const year = startDate.getFullYear();
    const hours = startDate.getHours();
    const minutes = startDate.getMinutes();
    const seconds = startDate.getSeconds();
    const milliseconds = startDate.getMilliseconds();
    const date: string = `${year}-${month}-${day}`;
    const timeStamp: string = `${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    const resultDate = `${date}T${timeStamp}`;
  
    return resultDate;
  }